import api from '../api';

export const login = (credentials) => {
    return api.post('/auth/loginsw', credentials);
};

export const getProfile = () => {
    return api.get('/auth/profile');
};
